import { ReactComponent as SettingTagIconSVG } from "./setting-tag-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconSettingTag(props) {
  return <SvgIcon {...props} component={SettingTagIconSVG} viewBox="0 0 117 117" />;
}